module.exports = __webpack_public_path__ + "static/image 1-1-ac6e2ff7e1f203bf744ba96e016dbbf7.png";